export const getClasses = (array: (string | undefined)[]): string =>
  array
    .filter((element) => element && element.trim().length > 0)
    .join(" ")
    .trim();
